import {
    NinchatActionType,
    NinchatGetTranscriptAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {NinchatTranscriptContentsEvent} from '../types/events'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const getTranscript = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatGetTranscriptAction}`,
    async (arg: NinchatActionParams<NinchatGetTranscriptAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatGetTranscriptAction

        try {
            return await ninchatClient.send(params) as NinchatTranscriptContentsEvent
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
